<template>
  <div id="app" class="bl-main font-body bg-slate-200 scrollbar-lg">
    <Header v-if="useHeader" />
    <div v-if="loading" class="h-screen w-screen grid place-items-center">
      <div
        class="flex items-center font-logo font-bold text-4xl text-light-purple animate-pulse"
      >
        Blüm
      </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    Header
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "viewMode"]),
    authPage() {
      return (
        this.$route.name === "Signin" ||
        this.$route.name === "ForgotPassword" ||
        this.$route.name === "ResetPassword" ||
        this.$route.name === "SetupAccount"
      );
    },
    publicPage() {
      return (
        this.$route.name === "Signin" ||
        this.$route.name === "ForgotPassword" ||
        this.$route.name === "ResetPassword" ||
        this.$route.name === "SetupAccount" ||
        this.$route.name === "ParentReport" ||
        this.$route.name === "ProspectForm"
      );
    },
    useHeader() {
      return (
        this.$route.name !== "Signin" &&
        this.$route.name !== "ForgotPassword" &&
        this.$route.name !== "ResetPassword" &&
        this.$route.name !== "SetupAccount" &&
        this.$route.name !== "CenterSalesPipelineFormPreview" &&
        this.$route.name !== "ProspectForm" &&
        this.$route.name !== "Report" &&
        this.$route.name !== "ParentReport" &&
        !this.$route.name.includes("SuperAdmin")
      );
    }
  },
  async created() {
    if (this.authPage) {
      document.body.style.overflow = "hidden";
    }

    if (this.publicPage) {
      const access = localStorage.getItem("access");
      if (access) {
        this.loading = true;
        const { success } = await this.getCurrentUser();
        this.loading = false;
        if (success && this.authPage) {
          const title = "You have signed in";
          this.showToast({ title, message: "", type: "success" });
          this.$router.replace("/clients");
        }
      }
    } else {
      this.loading = true;
      const { success } = await this.getCurrentUser();
      this.loading = false;
      if (!success) {
        this.$router.push({
          name: "Signin",
          query: { redirect: this.$route.fullPath }
        });
      }
    }
  },
  mounted() {
    const mediaQuery = window.matchMedia("(max-width: 1023px)");
    mediaQuery.addEventListener("change", this.resizeHandler);
    this.resizeHandler(mediaQuery);
    const event = new Event("resize");
    window.addEventListener("resize", () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
    window.dispatchEvent(event);
  },
  methods: {
    ...mapActions(["getCurrentUser", "setViewMode", "showToast"]),
    resizeHandler(e) {
      if (e.matches) this.setViewMode("mobile");
      else this.setViewMode("desktop");
    }
  }
};
</script>

<style scoped lang="scss">
.bl-main {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue